import { create, deleteData, get, update } from "./curdFunctions";
import {
  customer,
  ledgers,
  order,
  personalDetail,
  product,
  productType,
  productTypeWithHUID,
  productTypeWithOutHUID,
  reports,
  user,
} from "./endPoints";

/** Products */
const getProducts = () => {
  return get(product.getProducts);
};

const createProduct = (data) => {
  return create(product.createProduct, data);
};

const updateProduct = (data) => {
  return update(product.updateProduct, data);
};

const deleteProduct = (data) => {
  return update(product.deleteProduct, data);
};

/** Product Types */
const getProductTypes = () => {
  return get(productType.getProductTypes);
};

const getMovingHistories = () => {
  return get(productType.getMovingHistory);
};

const createProductType = (data) => {
  return create(productType.createProductType, data);
};

const updateProductType = (data) => {
  return update(productType.updateProductType, data);
};

const updatePairsByUniqueStockID = (data) => {
  return update(productType.updatePairsByUniqueStockID, data);
};

const deleteProductType = (data) => {
  return update(productType.deleteProductType, data);
};

const deleteDirectEntryProductType = (data) => {
  return update(productType.deleteDirectEntryProductType, data);
};

/** Product Types with out HUID*/
const getProductTypeWithOutHUIDs = (data) => {
  return create(productTypeWithOutHUID.getProductTypeWithOutHUIDs, data);
};

const createProductTypeWithOutHUID = (data) => {
  return create(productTypeWithOutHUID.createProductTypeWithOutHUID, data);
};

const createProductTypeWithOutHUIDTransactions = (data) => {
  return create(
    productTypeWithOutHUID.createProductTypeWithOutHUIDTransactions,
    data
  );
};

const updateProductTypeWithOutHUID = (data) => {
  return update(productTypeWithOutHUID.updateProductTypeWithOutHUID, data);
};

const moveProductTypeFunc = (data) => {
  return create(productTypeWithOutHUID.moveProductType, data);
};

const deleteProductTypeWithOutHUID = (data) => {
  return update(productTypeWithOutHUID.deleteProductTypeWithOutHUID, data);
};

const createHUID = (data) => {
  return create(productTypeWithOutHUID.createHUID, data);
};

const getHUIDs = () => {
  return get(productTypeWithOutHUID.getHUID);
};

const deleteHUIDs = (data) => {
  return create(productTypeWithOutHUID.deleteHUID, data);
};

/** Customer */
const getCustomers = () => {
  return get(customer.getCustomers);
};

const createCustomer = (data) => {
  return create(customer.createCustomer, data);
};

const updateCustomer = (data) => {
  return update(customer.updateCustomer, data);
};

const deleteCustomer = (data) => {
  return update(customer.deleteCustomer, data);
};

/** User */
const getUsers = (data) => {
  return create(user.getUsers, data);
};

const createUser = (data) => {
  return create(user.createUser, data);
};

const updateUser = (data) => {
  return update(user.updateUser, data);
};

const deleteUser = (data) => {
  return update(user.deleteUser, data);
};

/** Orders */
const getOrders = () => {
  return get(order.getOrders);
};

const getOrderProduct = (data) => {
  return create(order.getOrderProducts, data);
};

const createOrder = (data) => {
  return create(order.createOrder, data);
};

const createOrderProduct = (data) => {
  return create(order.createOrderProduct, data);
};

const updateOrder = (data) => {
  return update(order.updateOrder, data);
};

const updateOrderProduct = (data) => {
  return update(order.updateOrderProduct, data);
};

const deleteOrder = (data) => {
  return update(order.deleteOrder, data);
};

const deleteOrderProduct = (data) => {
  return update(order.deleteOrderProduct, data);
};

const checkHUIDStock = (data) => {
  return create(order.checkHUIDStocks, data);
};

const updateStocksByHUID = (data) => {
  return create(order.updateStocksByHUID, data);
};

/** Personal Details */
const getPersonalDetails = () => {
  return get(personalDetail.getPersonalDetails);
};

const createPersonalDetails = (data) => {
  return create(personalDetail.createPersonalDetails, data);
};

const updatePersonalDetails = (data) => {
  return update(personalDetail.updatePersonalDetails, data);
};

const deletePersonalDetails = (data) => {
  return update(personalDetail.deletePersonalDetails, data);
};

/** Reports */
const getOrderReports = () => {
  return get(reports.getOrderReports);
};

/** Ledgers */
const getLedgers = (data) => {
  return get(ledgers.getLedgers, data);
};

const getLedgersByCustomerID = (data) => {
  return create(ledgers.getLedgersByCustomerID, data);
};

const createLedger = (data) => {
  return create(ledgers.createLedger, data);
};

const updateLedger = (data) => {
  return update(ledgers.updateLedger, data);
};

const deleteLedger = (data) => {
  return update(ledgers.deleteLedger, data);
};

export {
  /** Products */
  getProducts,
  createProduct,
  updateProduct,
  deleteProduct,

  /** Products Types */
  getProductTypes,
  getMovingHistories,
  createProductType,
  updateProductType,
  deleteProductType,
  deleteDirectEntryProductType,
  updatePairsByUniqueStockID,

  /** Product Types with out HUID */
  getProductTypeWithOutHUIDs,
  createProductTypeWithOutHUID,
  createProductTypeWithOutHUIDTransactions,
  updateProductTypeWithOutHUID,
  deleteProductTypeWithOutHUID,
  moveProductTypeFunc,
  createHUID,
  getHUIDs,
  deleteHUIDs,

  /** Customers */
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,

  /** Users */
  getUsers,
  createUser,
  updateUser,
  deleteUser,

  /** Orders */
  getOrders,
  createOrder,
  createOrderProduct,
  updateOrder,
  updateOrderProduct,
  deleteOrder,
  getOrderProduct,
  deleteOrderProduct,
  checkHUIDStock,
  updateStocksByHUID,

  /** Personal Details */
  getPersonalDetails,
  createPersonalDetails,
  updatePersonalDetails,
  deletePersonalDetails,

  /** Ledger Reports */
  getOrderReports,
  getLedgers,
  createLedger,
  updateLedger,
  deleteLedger,
  getLedgersByCustomerID,
};
